export const phone_countries = [
  { name: "USA", text: "+1", value: "+1" },
  { name: "Russia", text: "+7", value: "+7" },
  { name: "Netherlands", text: "+31", value: "+31" },
  { name: "France", text: "+33", value: "+33" },
  { name: "Italy", text: "+39", value: "+39" },
  { name: "Switzerland", text: "+41", value: "+41" },
  { name: "United Kingdom", text: "+44", value: "+44" },
  { name: "Sweden", text: "+46", value: "+46" },
  { name: "Germany", text: "+49", value: "+49" },
  { name: "Argentina", text: "+54", value: "+54" },
  { name: "Malaysia", text: "+60", value: "+60" },
  { name: "Australia", text: "+61", value: "+61" },
  { name: "Philippines", text: "+63", value: "+63" },
  { name: "Singapore", text: "+65", value: "+65" },
  { name: "Thailand", text: "+66", value: "+66" },
  { name: "Japan", text: "+81", value: "+81" },
  { name: "Korea", text: "+82", value: "+82" },
  { name: "Vietnam", text: "+84", value: "+84" },
  { name: "Hong Kong", text: "+852", value: "+852" },
  { name: "China", text: "+86", value: "+86" },
  { name: "Taiwan", text: "+886", value: "+886" },
  { name: "Israel", text: "+972", value: "+972" },
];

export const country_abbreviation_to_country_code = {
  US: "+1",
  RU: "+7",
  NL: "+31",
  FR: "+33",
  IT: "+39",
  CH: "+41",
  GB: "+44",
  SE: "+46",
  DE: "+49",
  AR: "+54",
  MY: "+60",
  AU: "+61",
  PH: "+63",
  SG: "+65",
  TH: "+66",
  JP: "+81",
  KR: "+82",
  VN: "+84",
  HK: "+852",
  CN: "+86",
  TW: "+886",
  IL: "+972",
};
